import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { rootReducer } from "./rootReducer";
import { loadCartState } from "./cart/keepCart";
import { loadCartStateEP, loadPortfolioId, loadPortfolioName, loadCurrentState } from "./educationalcart/keepCart";
import { INITIAL_STATE as educationalCartInitialState } from "./educationalcart/reducer";

export type { RootState } from "./rootReducer";
export type { AppDispatch, AppThunk } from "./thunk";

function buildEducationalCartPreload()
{
    const loadedCart = loadCartStateEP();
    const modelPortfolioId = loadPortfolioId();
    const modelPortfolioName = loadPortfolioName();
    const currentState = loadCurrentState();

    return{
        ...educationalCartInitialState,
        ...(loadedCart || {}),
        ...(modelPortfolioId !== undefined ? { modelPortfolioId } : {}),
        ...(modelPortfolioName !== undefined ? { modelPortfolioName } : {}),
        ...(currentState !== undefined ? { current_state: currentState } : {}),
    };
}

export const store = createStore(
    rootReducer,
    {
        cart: loadCartState(),
        educationalCart: buildEducationalCartPreload(),
    },
    composeWithDevTools(applyMiddleware(thunkMiddleware))
);